export const iconFontAwesomeNumbers1 = (
	<i className="fa-solid fa-1"></i>
);
